<template>
  <div class="slider-pills">
    <div class="slider__link slider__actions--prev" ref="prevButton" v-if="filteredNumbers?.length > 4"><span>{{ __('Back to the previous ones') }}</span></div>
    <swiper 
      :modules="modules"
      :slides-per-view="4"
      :space-between="10"
      :navigation="{ prevEl: prevButton, nextEl: nextButton }"
      :breakpoints="{
      0: {
        slidesPerView: 2,
        grid: {
          rows: 2
        }
      },
      767: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        grid: {
          rows: 2
        }
      },
      1023: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
    }"
    ref="swiper">
      <swiper-slide v-if="filteredNumbers?.length && !isLoading" v-for="number in filteredNumbers" :key="number.id">
        <a href="#" class="pill" @click.prevent="$emit('clickedNumber', formattedNumber(number.number))">
          <span class="pill__inner">
            <span>
              {{ formattedNumber(number.number) }}
            </span>
  
            <div class="pill__icon">
              <IconSmartphone />
            </div><!-- /.pill__icon -->
          </span>
        </a><!-- /.pill -->
      </swiper-slide>
     
    </swiper>
    <div class="slider__button slider__actions--next" ref="nextButton" v-if="filteredNumbers?.length > 4"><span>{{ __('show more') }}</span></div>
  </div><!-- /.slider-pills -->
  <Loader v-if="isLoading" color="#2563eb" />
</template>

<script>
// Import Swiper core and required modules
import { ref, onMounted, inject, computed } from 'vue';
import { Navigation, Pagination, Scrollbar, A11y, Grid } from 'swiper/modules';
import { __, requestAvailableMsisdns, getFormValuesFromLocalStorage } from '@/utils';
import Loader from '@components/loader.vue';
import IconSmartphone from '@components/icons/icon-smartphone.vue'; 

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
  components: {
    IconSmartphone,
    Swiper,
    SwiperSlide,
    Loader,
  },
  emits: ['clickedNumber'],

  setup() {
    const prevButton = ref(null);
    const nextButton = ref(null);
    const displayedNumbers = ref([]);
    const isLoading = ref(true);

    const {
      availableMsisdns: cachedAvailableMsisdns,
      setAvailableMsisdns
    } = inject('step1');

    const formattedNumber = (number) => {
      if (number?.length > 3) {
        return number.slice(0, 3) + "-" + number.slice(3);
      } else {
        return number;
      }
    };

    const filteredNumbers = computed(() => {
      const formValues = getFormValuesFromLocalStorage();
      const currentNumbers = formValues?.phoneNumbers?.map((number) => number.number.replace('-', '')) || [];

      return displayedNumbers.value?.filter((number) => {
        return !currentNumbers.includes(number.number.replace('-', ''));
      }) || [];
    });
    
    const checkAvailableNumbers = async () => {

      try {
        let response = null;
        //if(!cachedAvailableMsisdns?.value?.data?.length) {
        if(true) {
          response = await requestAvailableMsisdns();
          setAvailableMsisdns(response);
        }
        if (cachedAvailableMsisdns?.value?.data?.length || response?.data.length){
          displayedNumbers.value = cachedAvailableMsisdns?.value?.data || response.data;
        }
      } catch (error) {
        console.error('Error fetching plans:', error);
      }finally {
        isLoading.value = false;
      }

    };

    onMounted(() => {
      checkAvailableNumbers();
    });

    return {
      prevButton,
      nextButton,
      filteredNumbers,
      modules: [Navigation, Pagination, Scrollbar, A11y, Grid],
      formattedNumber,
      __,
      isLoading,
    };
  },
};
</script>
